import React, { useEffect } from 'react'
import { clearUrlFromGETParamaters, getGETParametersString, getLandingId, getQuery } from "@common-helpers/url-helper"
import { sendEventToArbitration } from "@common-helpers/arbitration-helper"

import { setPathForRouter } from '@common-helpers/set-rout-path'

export function initLanding(initCallback = () => true) {

    const landingId = getLandingId(),
        redirectComponentPath = getQuery().get('redirect-to'),
        hasRedirectComponentPath = redirectComponentPath,
        redirect = setPathForRouter(`${landingId}/${redirectComponentPath}`)

    console.log(landingId)


    useEffect(() => {

        const clickId = getQuery().get('click_id'),
            flowId = getQuery().get('flowid')

        if (clickId) {
            const getProps = window.location.href.replace(window.location.origin, '').replace(window.location.pathname, '')

            localStorage.setItem('get_props', getProps)
        }

        const GETParametersString = getGETParametersString(),
            hasClickId = clickId,
            hasLandingId = landingId

        if (hasRedirectComponentPath) redirect()

        hasLandingId ? localStorage.setItem('landingId', landingId) : localStorage.removeItem('landingId')
        hasClickId ? localStorage.setItem('click_id', clickId) : localStorage.removeItem('click_id')
        flowId ? localStorage.setItem('flowid', flowId) : localStorage.removeItem('flowid')

        localStorage.setItem('GET-parameters-string', GETParametersString)

        sendEventToArbitration(1, 'INIT')
        sendEventToArbitration(1, 'TEST1')
        clearUrlFromGETParamaters()

        initCallback()
    }, [])

}